export default __webpack_public_path__ + "static/media/MALETAS.1b2dc49f.png";